<template>
  <base-row
    v-bind="$props"
    :selectable="false"
  >
    <td class="max-w-xs truncate">
      <Link
        v-if="hasRoute && productShowRoute"
        :href="productShowRoute"
        class="uppercase font-semibold text-blue-600 hover:underline hover:text-blue-600"
      >
        #{{ item.product_id }}
        <span v-if="item.product_name"> ({{ item.product_name }}) </span>
      </Link>
      <span
        v-else
        class="text-blue-600 hover:text-blue-600 hover:underline"
      >
        #{{ item.product_id }}
        <span v-if="item.product_name"> ({{ item.product_name }}) </span>
      </span>
    </td>
    <td>
      {{ item.price ? _dollars(item.price) : '-' }}
    </td>
    <td>
      {{ item.quantity }}
    </td>
    <td>
      {{ item.subtotal ? _dollars(item.subtotal) : '-' }}
    </td>
    <td>
      {{ item.discount_amount ? _dollars(item.discount_amount) : '-' }}
      <div v-if="item.discount_reason">
        <small>{{ item.discount_reason }}</small>
      </div>
    </td>
    <td>
      {{ item.total ? _dollars(item.total) : '-' }}
    </td>
    <td>
      {{ item.total_refunded ? _dollars(item.total_refunded) : '-' }}
    </td>
    <td>
      <a
        title="Has packages attached"
        class="text-blue-400"
      >
        <CheckCircleIcon
          v-if="item.has_packages"
          class="ag-grid-cell-ico"
        />
      </a>
      <a
        title="Missing packages"
        class="text-red-400"
      >
        <ExclamationCircleIcon
          v-if="!item.has_packages"
          class="ag-grid-cell-ico"
        />
      </a>
    </td>
  </base-row>
</template>

<script>
import { Link } from '@inertiajs/vue3'
import TableRow from '@/Components/Table/TableRow'
import RowProps from '@/Components/Table/Mixins/RowProps'
import BasicBadge from '@/Components/Badges/BasicBadge.vue'
import _dollars from '@/Filters/Dollars'
import { CheckCircleIcon } from '@heroicons/vue/outline'
import { ExclamationCircleIcon } from '@heroicons-2/vue/24/outline'

export default {
  components: {
    ExclamationCircleIcon,
    CheckCircleIcon,
    'base-row': TableRow,
    BasicBadge,
    Link
  },

  mixins: [RowProps],

  props: {
    /**
     * A function that we can use to generate the URL to view a product. Returns a string that is a valid URL
     */
    showRoute: {
      type: Function,
      default: (item) => null
    }
  },

  computed: {
    /**
     * Returns the URL we can use to view a product
     */
    productShowRoute() {
      return this.showRoute(this.item)
    },

    /**
     * Returns true if this product has a valid URL to view a product
     * @returns {boolean}
     */
    hasRoute() {
      return this.productShowRoute !== null
    }
  },

  methods: {
    _dollars
  }
}
</script>
